/**
 * TanStack Query hooks for `contest-promotion-manager`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	contestPromotionManagerQueryKeys,
	type CreateContestPromotionManagerBody,
	type ListContestPromotionManagerResponse,
	type ContestPromotionManagerRow,
} from "./api";

export function useContestPromotionManagerList(): UseQueryResult<ListContestPromotionManagerResponse, Error> {
	return useQuery({
		queryKey: contestPromotionManagerQueryKeys.list(),
		queryFn: list,
	});
}

export function useContestPromotionManagerCreate(): UseMutationResult<ContestPromotionManagerRow, Error, CreateContestPromotionManagerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: contestPromotionManagerQueryKeys.all });
		},
	});
}

export function useContestPromotionManagerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: contestPromotionManagerQueryKeys.all });
		},
	});
}
